import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ScrollReveal from 'scrollreveal';
import cmtiLogo from "../../images/LandingPage/cmti-logo.png";
import smFoundry from "../../images/LandingPage/foundry.png";
import Ficon from "../../images/LandingPage/icon.png";
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const scrollRevealOption = {
      distance: "50px",
      origin: "bottom",
      duration: 1000,
    };

    ScrollReveal().reveal(".page_container .letter-s", {
      duration: 1000,
      delay: 1000,
    });
    ScrollReveal().reveal(".page_container img", {
      duration: 1000,
      delay: 1500,
    });
    ScrollReveal().reveal(".page_container .text__left", {
      ...scrollRevealOption,
      origin: "right",
      delay: 2000,
    });
    ScrollReveal().reveal(".page_container .text__right", {
      ...scrollRevealOption,
      origin: "left",
      delay: 2000,
    });
    ScrollReveal().reveal(".page_container .text__center", {
      ...scrollRevealOption,
      origin: "top",
      delay: 2000,
    });
    ScrollReveal().reveal(".page_container .explore", {
      duration: 1000,
      delay: 2500,
    });
    ScrollReveal().reveal(".page_container h5", {
      duration: 1000,
      interval: 500,
      delay: 3000,
    });
    ScrollReveal().reveal(".page_container .catalog", {
      duration: 1000,
      delay: 5000,
    });
    ScrollReveal().reveal(".page_container .print", {
      duration: 1000,
      delay: 5500,
    });
    ScrollReveal().reveal(".page_container .patterns", {
      duration: 1000,
      delay: 2000,
    });
  }, []);

  const handleExploreMore = () => {
    navigate('/dashboard');
  };

  return (
    <div className='page_body'>
      <div className="page_container">

        <nav className="page_nav p-5 flex justify-between items-center">
          <ul className="nav__links grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 w-full">
            <li className="page_logo col-span-1 flex justify-center">
              <a href="/" className="logo flex items-center">
                <img src={Ficon} alt="Smart Foundry 4.0" />
              </a>
            </li>
            <li className="col-span-2 md:col-span-3 lg:col-span-4 flex justify-center items-center">
              <div className="patterns w-full flex items-center justify-center">
                <svg className="w-full h-24">
                  <rect x="0" y="0" width="100%" height="100%" fill="url(#polka-dots)"></rect>
                  <text className="text_pattern text-lg md:text-xl lg:text-2xl font-bold" x="50%" y="50%" textAnchor="middle" alignmentBaseline="middle">
                    Integrated Smart Foundry
                  </text>
                </svg>
              </div>
            </li>
            <li className="cmtiLogo col-span-1 flex justify-center">
              <a href="/" className="logo flex items-center">
                <img src={cmtiLogo} alt="CMTI" />
              </a>
            </li>
          </ul>
        </nav>


        <div className="page_div">
          <span className="letter-s">S</span>
          <div className='page_image'>
            <img src={smFoundry} alt="Smart Foundry 4.0" />
          </div>
          <h4 className="text__left">SMART</h4>
          <h4 className="text__right">FOUNDRY </h4>
          <h4 className="text__center">4.0</h4>
          <button className="page_btn explore" onClick={handleExploreMore}>EXPLORE MORE</button>
          <button className="page_btn print">PRINT</button>
          <button className="page_btn catalog">CATALOG</button>

          <Link to="/melt">
            <h5 className="feature-4">Melting & Pouring</h5>
          </Link>
          <Link to="/mould">
            <h5 className="feature-3">Sand mixing & Mould making</h5>
          </Link>
          <Link to="/printer">
            <h5 className="feature-2">Pattern Printing</h5>
          </Link>
          <Link to="/process">
            <h5 className="feature-1">Process Design</h5>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
